import { isRouteErrorResponse, useRouteError } from 'react-router'

export function useCapturedRouteError() {
  const error = useRouteError()
  if (isRouteErrorResponse(error)) {
    if (error.status < 500) return error
    // TODO: add sentry
    // Sentry.captureException(getRouteErrorResponseException(error), {
    //   extra: {
    //     route_error_response: {
    //       status: error.status,
    //       statusText: error.statusText,
    //       data: error.data
    //     }
    //   }
    // })

    return error
  }
  // TODO: add sentry
  // Sentry.captureException(error)

  return error
}

export function getErrorMessage(
  error: unknown,
  fallback: string = 'Unknown Error'
) {
  if (typeof error === 'string') return error
  if (error instanceof Error) return error.message

  return fallback
}
